/**
 *  ----- ONLY FOR DEVELOPMENT TEST -----
 * This file contains methods to return some responses 
 * according the modals in each section.
 * How to use: 
 * 1. import
import { CoreResponseUtilsService } from '@core/services/utils/response-utils.service';
 * 2. add service to constructor
private responseUtilsSrv:CoreResponseUtilsService
 * 3. use the proper method in the service to return a correct response.
return this.responseUtilsSrv.simulate500InternalServerError()
 * 4. how to use to simulate get response
 return this.responseUtilsSrv.simulate200SuccessResponse<CUSTOMTYPE>(value).pipe(
          map(response => response.body as CUSTOMTYPE)
        );
 */
import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { delay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CoreResponseUtilsService {
    // Method to simulate a 403 Forbidden response
    simulate403ForbiddenResponse(timer?:boolean): Observable<never> {
        const errorResponse = new HttpErrorResponse({
          error: 'Forbidden',
          status: 403,
          statusText: 'Forbidden',
        });
        return timer? throwError(() => errorResponse).pipe(delay(3000)) : throwError(() => errorResponse);
    }

    // Method to simulate a 406 Not Acceptable response with custom error code
    simulate406NotAcceptableResponse(errorCode: string = "Data not Acceptable", timer?: boolean): Observable<never> {
      const errorResponse = new HttpErrorResponse({
        error: { code: errorCode }, // Include the specific error code in the body
        status: 406,
        statusText: 'Not Acceptable',
      });
      return timer ? throwError(() => errorResponse).pipe(delay(3000)) : throwError(() => errorResponse);
    }
    // Method to simulate a 425 Too Early response
    simulate425TooEarlyResponse(timer?:boolean): Observable<never> {
      const errorResponse = new HttpErrorResponse({
        error: 'Too Early',
        status: 425,
        statusText: 'Too Early',
      });
      return timer? throwError(() => errorResponse).pipe(delay(3000)) : throwError(() => errorResponse);
    }

    // Method to simulate a 201 Created response with some body data Without calling backend
    simulate201CreatedResponse(): Observable<HttpResponse<any>> {
      const body = {value: "example"}; // Optionally, we can include a response body here
      return of(new HttpResponse({
        status: 201,
        body: body,
      }));
    }

    // Method to simulate a 200 OK response with dynamic body data without calling backend
    simulate200SuccessResponse<T>(data: T): Observable<HttpResponse<T>> {
      return of(new HttpResponse<T>({
        status: 200,
        body: data,
      }));
    }

    // Method to simulate a 500 Server Error response
    simulate500InternalServerError(url:string = '', timer?:boolean): Observable<never> {
      const errorResponse = new HttpErrorResponse({
        error: 'Internal Server Error',
        status: 500,
        statusText: 'Forced Internal Server Error',
        url: url
      });
      return timer? throwError(() => errorResponse).pipe(delay(8000)) : throwError(() => errorResponse);
    }

    // New method to simulate no response (timeout)
    simulateNoResponseTimeout(seconds: number = 10): Observable<any> {
      // Simulate a response that takes seconds (longer than a set timeout where it was called)
      return of([]).pipe(delay(seconds * 1000)); // Returns empty array after given seconds
    }


}
